import * as actionTypes from "./actionTypes"
export function getChoosenMovieSuccess(movie){
    return{type:actionTypes.GET_CHOOSEN_MOVIE_SUCCESS, payload:movie}
}


export function getMovie(movieId){
    const api = "a87898297a078d85fecce7aab9d8dbde";
    return function(dispatch){
        let url;
        if(movieId){
            url = `https://api.themoviedb.org/3/movie/${movieId}?api_key=${api}&language=en-US`
        }
        else{
            url = `https://api.themoviedb.org/3/460465/460465?api_key=${api}&language=en-US`
        }
        
        return  fetch(url).then(response => response.json())
        .then(result => dispatch(getChoosenMovieSuccess(result)))
    }

  
}

